export const typography = {
  fontFamilyBase: '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontFamilyDisplay: '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSizeXss: '11.375px',
  fontSizeXs: '12px',
  fontSizeSm: '13px',
  fontSizeMd: '14px',
  fontSizeBase: '15px',
  fontSizeLg: '16px',
  fontSizeXl: '18px',
  fontSize2xl: '20px',
  fontSize3xl: '24px',
  fontSize4xl: '30px',
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
  fontWeightBold: 700,
  lineHeightTight: 1.2,
  lineHeightHeading: 1.3,
  lineHeightBody: 1.5,
  lineHeightRelaxed: 1.65,
};

export const typographyVars = {
  'font-family-base': typography.fontFamilyBase,
  'font-size-xs': typography.fontSizeXs,
  'font-size-sm': typography.fontSizeSm,
  'font-size-md': typography.fontSizeMd,
  'font-size-base': typography.fontSizeBase,
  'font-size-lg': typography.fontSizeLg,
  'font-size-xl': typography.fontSizeXl,
  'font-size-2xl': typography.fontSize2xl,
  'font-size-3xl': typography.fontSize3xl,
  'font-size-4xl': typography.fontSize4xl,
  'font-weight-regular': typography.fontWeightRegular,
  'font-weight-medium': typography.fontWeightMedium,
  'font-weight-semibold': typography.fontWeightSemibold,
  'font-weight-bold': typography.fontWeightBold,
  'line-height-tight': typography.lineHeightTight,
  'line-height-heading': typography.lineHeightHeading,
  'line-height-body': typography.lineHeightBody,
  'line-height-relaxed': typography.lineHeightRelaxed,
};

export const typographyStyles = {
  pageTitle: {
    fontSize: typography.fontSize3xl,
    fontWeight: typography.fontWeightSemibold,
    lineHeight: typography.lineHeightHeading,
  },
  sectionTitle: {
    fontSize: typography.fontSizeXl,
    fontWeight: typography.fontWeightSemibold,
    lineHeight: typography.lineHeightHeading,
  },
  cardTitle: {
    fontSize: typography.fontSizeLg,
    fontWeight: typography.fontWeightSemibold,
    lineHeight: typography.lineHeightHeading,
  },
  bodyText: {
    fontSize: typography.fontSizeMd,
    fontWeight: typography.fontWeightRegular,
    lineHeight: typography.lineHeightBody,
  },
  caption: {
    fontSize: typography.fontSizeXs,
    fontWeight: typography.fontWeightRegular,
    lineHeight: typography.lineHeightBody,
  },
};
